import { Input } from "antd";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useState } from "react";
import { Button } from "../../../BP2Components";

export const BenefitsChartSettings = ({ value }) => {
   const [listId, setListId] = useState<string>(value.listId || "");
   const intl = useIntl();
   const dispatch = useDispatch();

   const handleSave = () => {
      dispatch(
         setWidgetInSheetParams({
            ...value,
            listId,
         }),
      );
   };

   return (
      <div className="summaries-settings">
         <label className="widget-settings__inner__label">
            {intl.formatMessage({ id: "settings.listId" })}:
            <Input onChange={(e) => setListId(e.target.value)} value={listId} />
         </label>
         <Button onClick={handleSave} buttonType="primary">
            {intl.formatMessage({ id: "global.save" })}
         </Button>
      </div>
   );
};
